import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { LettrageModel } from 'src/graphql/generated-types';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { KalTableHeader } from 'src/app/_shared/modules/kal-table/kal-table.module';

export interface LetteredBookEntriesDialogData {
    message?: string;
    accepted?: boolean;
    letteredBookEntries: LettrageModel[];

}

@Component({
    selector: 'app-lettered-book-entries-dialog',
    templateUrl: './lettered-book-entries-dialog.component.html',
    styleUrls: ['./lettered-book-entries-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LetteredBookEntriesDialogComponent extends BaseComponent implements OnInit {

    letteredBookEntriesList: LettrageModel[] = [];

    columns: KalTableHeader<LettrageModel>[] = [
        {label: 'Lettre', code: 'Lettre'},
        {label: 'Utilisateur', code: 'Utilisateur'},
        {label: 'Délégation cible', code: 'NomDelegCibleEcriture'},
        {label: 'Journal', code: 'CodeJournal'},
        {label: 'N° piece', code: 'NumeroPiece'},
        {label: 'Date', code: 'DateEcriture'},
        {label: 'Collectif', code: 'CompteCollectif'},
        {label: 'Tiers', code: 'NomPrenomBenef'},
        {label: 'Libellé', code: 'LibelleMouvement'},
        {label: 'Debit', code: 'Debit'},
        {label: 'Credit', code: 'Credit'},
    ];

    constructor(protected cdr: ChangeDetectorRef,
                private dialogRef: KalDialogRef<LetteredBookEntriesDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: LetteredBookEntriesDialogData) {
        super(cdr);
    }

    cancel(): void {
        this.dialogRef.close();
    }

    confirm(): void {
        this.dialogRef.close({
            accepted: true
        });
    }

    ngOnInit(): void {
        this.letteredBookEntriesList = this.data.letteredBookEntries;
        this.cdr.markForCheck();
    }

}
